import React, { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';

import ActivityCard from 'components/ActivityCard';
import AssessmentIcon from '@material-ui/icons/Assessment';

import { useStyles } from '../styles';

interface IProps {
  activityReport: any; // TODO: improve this
  withoutPaper?: boolean;
  withoutIcon?: boolean;
}

const ActivityCounter: React.FC<IProps> = ({ activityReport, withoutPaper, withoutIcon }) => {
  const classes = useStyles();
  const activityCounter = useMemo(() => {
    if (!activityReport) return 0;
    return (
      (activityReport.metricsGauges.length && activityReport.metricsGauges[0].totalActivity) || 0
    );
  }, [activityReport]);

  const activityChange = useMemo(() => {
    if (!activityReport) return 0;
    return (
      (activityReport.metricsGauges.length &&
      activityReport.previousMetricsGauges.length &&
      activityReport.previousMetricsGauges[0].totalActivity !== 0
        ? (100 *
            (activityReport.metricsGauges[0].totalActivity -
              activityReport.previousMetricsGauges[0].totalActivity)) /
          ((activityReport.metricsGauges[0].totalActivity +
            activityReport.previousMetricsGauges[0].totalActivity) /
            2)
        : 100) || 0
    );
  }, [activityReport]);

  return (
    <>
      {!withoutPaper ? (
        <Paper className={classes.paper}>
          <ActivityCard
            icon={<AssessmentIcon style={{ marginRight: '5px' }} />}
            title={'Workspace Activity'}
            data={activityCounter}
            change={activityChange}
            withoutIcon={withoutIcon}
          />
        </Paper>
      ) : (
        <ActivityCard
          icon={<AssessmentIcon style={{ marginRight: '5px' }} />}
          title={'Total Activity'}
          data={activityCounter}
          change={activityChange}
          withoutIcon={withoutIcon}
        />
      )}
    </>
  );
};

export { ActivityCounter };
